// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.em-cntrg {
    fill: #e1e1e1;
    cursor: pointer !important;
}
`, "",{"version":3,"sources":["webpack://./src/css/countries.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,0BAA0B;AAC9B","sourcesContent":[".em-cntrg {\r\n    fill: #e1e1e1;\r\n    cursor: pointer !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
